/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Action } from '@ngrx/store';
import { StaticDataType } from 'app/static-data/models';
import { NamedValue } from 'app/shared/models';

// -------------------------------------------------------------------------
// Load all static data values
export const LOAD_ALL_STATIC_DATA_VALUES = '[Static Data] Load All Static Data Values';

// -------------------------------------------------------------------------
// Load static data values
export const LOAD_STATIC_DATA_VALUES = '[Static Data] Load Static Data Values';
export const LOAD_STATIC_DATA_VALUES_SUCCESS = '[Static Data] Load Static Data Values Success';
export const LOAD_STATIC_DATA_VALUES_ERROR = '[Static Data] Load Static Data Values Error';

// -------------------------------------------------------------------------
// Load all static data values
export class LoadAllStaticDataValues implements Action {
  readonly type = LOAD_ALL_STATIC_DATA_VALUES;
}

// -------------------------------------------------------------------------
// Load static data values
export class LoadStaticDataValues implements Action {
  readonly type = LOAD_STATIC_DATA_VALUES;

  constructor(public enumType: StaticDataType) {}
}

export class LoadStaticDataValuesSuccess implements Action {
  readonly type = LOAD_STATIC_DATA_VALUES_SUCCESS;

  constructor(public enumType: StaticDataType, public namedValues: NamedValue<string>[]) {}
}

export class LoadStaticDataValuesError implements Action {
  readonly type = LOAD_STATIC_DATA_VALUES_ERROR;

  constructor(public enumType: StaticDataType, public errorMessage: string) {}
}

// -------------------------------------------------------------------------
export type All =
  | LoadAllStaticDataValues
  | LoadStaticDataValues
  | LoadStaticDataValuesSuccess
  | LoadStaticDataValuesError;
